// TODO 把客製化部分移入app/layout裡面
import React from 'react'
import { createMuiTheme, ThemeProvider } from '@material-ui/core'
// import { zhTW } from 'app/locale'

const defaultTheme = createMuiTheme(
  /**
   * @see https://material-ui.com/customization/themes/#theme-configuration-variables
   */
  {
    // direction: "rtl",
    typography: {
      fontFamily: ['Poppins'].join(','),
    },

    palette: {
      primary: {
        // light: will be calculated from palette.primary.main,
        main: '#2196f3',
        // dark: will be calculated from palette.primary.main,
        contrastText: '#fff', //will be calculated to contrast with palette.primary.main
      },
      secondary: {
        light: '#f1f2f3',
        main: '#cfd8dc',
        // dark: will be calculated from palette.primary.main,
        // contrastText: "#fff" //will be calculated to contrast with palette.primary.main
      },
      error: {
        // light: will be calculated from palette.primary.main,
        main: '#dd022a',
        // dark: will be calculated from palette.primary.main,
        // contrastText: "#fff" //will be calculated to contrast with palette.primary.main
      },
      text: {
        hint: '#8b7696',
        secondary: '#b19bbf',
        primary: '#02142b',
        primaryLight: '#50698a'
      },
    },

    /**
     * @see https://material-ui.com/customization/globals/#default-props
     */
    props: {
      MuiButtonBase: {
        disableRipple: false, // No more ripple, on the whole application 💣!
      },
      MuiPopover: {
        elevation: 1,
      },
    },
  },
  // zhTW,
)
const theme = createMuiTheme({
  ...defaultTheme,
  overrides: {
    MuiTable: {
      root: {
        borderBottom: '1px solid rgba(224, 224, 224, 1)'
      }
    },
    MuiAutocomplete: {
      groupLabel: {
        backgroundColor: defaultTheme.palette.secondary.light,
        lineHeight: '24px',
        margin: '8px 0'
      }
    },
    MuiTableRow: {
      root: {
        '&.MuiTableRow-hover': {
          '&:hover': {
            backgroundColor: 'rgb(33 147 202 / 7%)',
          }
        }
      },
    },
    MuiTableCell: {
      head: {
        backgroundColor: defaultTheme.palette.secondary.light,
        color: defaultTheme.palette.text.primaryLight,
        lineHeight: 1.3
      },
      body: {
        '&:not(:first-child)': {
          borderLeft: '1px solid rgb(0 0 0 / 7%)'
        }
        // root: {
        // },
      }
    },
    MuiSnackbarContent: {
      root: {
        backgroundColor: '#ffa000',
        color: '#02142b',
      },
    },
    MuiDialog: {
      paper: {
        borderRadius: 10,
      },
    },
    MuiDialogTitle: {
      root: {
        padding: '16px 16px 8px 16px',
      },
    },
    MuiFormControl: {
      marginDense: {
        marginLeft: 4,
        marginRight: 4,
        marginBottom: 8,
      },
    },
    MuiDialogActions: {
      root: {
        padding: '16px',
      },
    },
    MuiDialogContent: {
      root: {
        '&.fullWidth': {
          padding: '8px 0',
        },
      },
    },
    MuiTab: {
      root: {
        '&.mainTab': {
          fontSize: '1.05rem',
        },
      },
    },
    MuiExpansionPanelDetails: {
      root: {
        '&.noPadding': {
          padding: 0,
        },
      },
    },
    MuiPaper: {
      root: {
        '&.info': {
          padding: '16px 16px',
          backgroundColor: 'rgba(255, 255, 255, .5)',
          boxShadow: 'none',
          '&.noPadding': {
            padding: '0',
          },
        },
      },
    },
    MuiFormHelperText: {
      root: {
        fontSize: '.9rem',
      },
    },
    MuiButton: {
      root: {
        '&.danger': {
          background: '#ff1574',
          color: '#FFF',
          '&:hover': {
            backgroundColor: '#c4135a',
            '@media (hover: none)': {
              backgroundColor: '#c4135a',
            },
          },
        },
        '&:noMargin': {
          margin: 0,
        },
      },
      outlined: {
        color: '#667177',
      },
    },
  },
})
export function MaterialThemeProvider(props) {
  const { children } = props
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
